exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".section {\n  background: white;\n  padding: 20px;\n  margin-top: 10px;\n  width: 100%;\n  box-sizing: border-box;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/core/Section/style.scss
// module id = 1042
// module chunks = 0